import zipcodeApi from '~/clientApis/zipcodeApi';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import { getStore } from '~/mobx/AppStore';
import { ZipCodeParser } from '~/utils/zipCodeParser';

const deleteZipcode = async () => {
    const { zipcodeStore, regionStore } = getStore();
    const regionId = regionStore.selectedRegionId;
    const zipCodesToDelete = zipcodeStore.zipCodesToDelete.join(',');
    const parsedExistingZipcode = ZipCodeParser.parse(zipcodeStore.selectedZipcode);
    const mergedZipcodeToUpdate = ZipCodeParser.removeZipCodes(parsedExistingZipcode, zipCodesToDelete);
    const stringifiedMergedZipcodeToUpdate = ZipCodeParser.stringify(mergedZipcodeToUpdate);
    const expandedRangesStr = ZipCodeParser.getExpandedRanges(stringifiedMergedZipcodeToUpdate).expandedRangesStr;
    const activeRangeId = ZipCodeParser.findPreviousZipcodeSegment(zipCodesToDelete, expandedRangesStr);

    const params = {
        regionId: regionId,
        data: {
            value: stringifiedMergedZipcodeToUpdate,
        },
    };

    zipcodeStore.setIsGettingZipcode(true);

    try {
        await zipcodeApi.updateZipcode({ ...params });
        zipcodeStore.setSelectedZipcode(stringifiedMergedZipcodeToUpdate);
        zipcodeStore.setSelectedRangeId(activeRangeId);
        zipcodeStore.setZipCodesToDelete([]);
        await zipcodeStore.getZipcodeListAndPagination();
    } catch (error) {
        showMessageModal('error', 'Error deleting zipcode');
        throw error;
    } finally {
        zipcodeStore.setIsGettingZipcode(false);
    }
};

export default deleteZipcode;
